module.exports = __webpack_public_path__ + "static/media/family_icon_blue.edaaa769.svg";